import UnitDetails, { getServerSideProps as gSSP } from '../../components/pages/UnitDetail';
import React, { FC } from 'react';
import { GetServerSideProps } from 'next';
import { brandConfig } from '../_app';

const UnitDetailsDE: FC<React.PropsWithChildren<{ id?: string }>> = props => (
    <UnitDetails key={props.id} pageSlug="unterkunft" {...props} />
);
export default UnitDetailsDE;

export const getServerSideProps: GetServerSideProps = ctx => gSSP(brandConfig, ctx);
